import React from "react";
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import classnames from 'classnames';

import {Svg} from "../../../components/svg";
import {ChecklistItem, BUTTON_TYPES} from "./checklist-item";

import copy from './copy.json';


export const IncomeVerificationChecklistItem = inject('completeMyPaperworkStore', 'historyStore')(
    observer(
        class _IncomeVerificationChecklistItem extends React.Component {
            static propTypes = {
                historyStore: PropTypes.shape({
                    history: PropTypes.shape({
                        push: PropTypes.func.isRequired
                    }),
                }).isRequired,
                completeMyPaperworkStore: PropTypes.shape({
                    hasSubmittedIncomeVerification: PropTypes.bool.isRequired,
                    isIncomeVerificationAccepted: PropTypes.bool.isRequired,
                    isIncomeVerificationComplete: PropTypes.bool.isRequired,
                    getPaperworkUrl: PropTypes.func.isRequired,
                }).isRequired,
                isBrpFinancialTheme: PropTypes.bool,
            };

            copy = copy.income_verification;

            getSubText() {
                const {completeMyPaperworkStore} = this.props;

                if (!completeMyPaperworkStore.hasSubmittedIncomeVerification) {
                    return null;
                }
                if (!completeMyPaperworkStore.isIncomeVerificationComplete) {
                    return this.copy.processing_text;
                }
                if (!completeMyPaperworkStore.isIncomeVerificationAccepted) {
                    return this.copy.rejected_text;
                }
                return null;
            }

            getButtonType() {
                const {completeMyPaperworkStore} = this.props;
                if (completeMyPaperworkStore.isIncomeVerificationAccepted) {
                    return BUTTON_TYPES.DONE;
                }
                if (completeMyPaperworkStore.isIncomeVerificationComplete) {
                    return BUTTON_TYPES.RESUBMIT;
                }
                return BUTTON_TYPES.SUBMIT_DOCS;
            }

            goToIncomeVerification = () => {
                let cmpStore = this.props.completeMyPaperworkStore;
                let applicantUuid = cmpStore[`${cmpStore.prefix}Uuid`];
                this.props.historyStore.history.push(
                    cmpStore.getPaperworkUrl('/income-verification', applicantUuid)
                );
            };

            render() {
                const {
                    isIncomeVerificationAccepted,
                } = this.props.completeMyPaperworkStore;
                const checklistItemProps = {
                    title: this.copy.title,
                    buttonType: this.getButtonType(),
                    isBrpFinancialTheme: this.props.isBrpFinancialTheme,
                };
                if (!isIncomeVerificationAccepted) {
                    checklistItemProps.onClickButton = this.goToIncomeVerification;
                }

                const subText = this.getSubText();
                return (
                    <ChecklistItem {...checklistItemProps}>
                        {subText && (
                            <div className="border-top border-secondary mt-3 pt-2">
                                <Svg className={classnames("mr-2", this.props.isBrpFinancialTheme ? "spark-text-primary" : "spark-text-note")} svg="processing-icon"/>
                                <span className="spark-text-14px-bold">
                                    {subText}
                                </span>
                            </div>
                        )}
                    </ChecklistItem>
                );
            }
        }
    )
);
